import api from './client';
import type { DevTicket, DevTicketStatus } from 'types/dev_ticket';

export const devTicketsApi = {
  list: async (status?: DevTicketStatus): Promise<DevTicket[]> => {
    const params = status ? { status } : {};
    const { data } = await api.get('/dev-tickets', { params });
    return data;
  },

  updateStatus: async (ticketId: string, status: DevTicketStatus): Promise<DevTicket> => {
    const { data } = await api.patch(`/dev-tickets/${ticketId}/status`, { status });
    return data;
  },

  create: async (ticket: Omit<DevTicket, 'id'>): Promise<DevTicket> => {
    const { data } = await api.post('/dev-tickets', ticket);
    return data;
  },

  delete: async (ticketId: string): Promise<void> => {
    await api.delete(`/dev-tickets/${ticketId}`);
  },
};
